import { createAction, createAsyncActions } from './utils';

const reducer = 'TENANT_PROFILE';

const { action: getTenantProfile, actionSuccess: getTenantProfileSuccess, actionFail: getTenantProfileFail } = createAsyncActions(reducer, 'GET');
const { action: getPublicTenantProfile, actionSuccess: getPublicTenantProfileSuccess, actionFail: getPublicTenantProfileFail } = createAsyncActions(reducer, 'GET_PUBLIC');
const { action: saveTenantProfile, actionSuccess: saveTenantProfileSuccess, actionFail: saveTenantProfileFail } = createAsyncActions(reducer, 'SAVE');
const { action: revokeProfileSlug, actionSuccess: revokeProfileSlugSuccess, actionFail: revokeProfileSlugFail } = createAsyncActions(reducer, 'REVOKE_SLUG');
const { action: regenerateProfileSlug, actionSuccess: regenerateProfileSlugSuccess, actionFail: regenerateProfileSlugFail } = createAsyncActions(reducer, 'REGENERATE_SLUG');
const clearPublicProfile = createAction(reducer, 'CLEAR_PUBLIC');

export {
    getTenantProfile, getTenantProfileSuccess, getTenantProfileFail,
    getPublicTenantProfile, getPublicTenantProfileSuccess, getPublicTenantProfileFail,
    saveTenantProfile, saveTenantProfileSuccess, saveTenantProfileFail,
    revokeProfileSlug, revokeProfileSlugSuccess, revokeProfileSlugFail,
    regenerateProfileSlug, regenerateProfileSlugSuccess, regenerateProfileSlugFail,
    clearPublicProfile
};
